import MenuEntityConfigs from './entities/index.js';
export * from './constants.js';
export * from './posEntityKey.js';
export * from './posGate/index.js';
export * from './quality.js';
export * from './uberPosKey.js';
export const isMenuEntityWithImage = (value) => {
    return getConfiguration(value).hasImage;
};
export const getConfiguration = (collection) => MenuEntityConfigs[collection].configuration;
export default {
    Category: getConfiguration('Category'),
    Item: getConfiguration('Item'),
    Coupon: getConfiguration('Coupon'),
    Menu: getConfiguration('Menu'),
    ModifierSet: getConfiguration('ModifierSet'),
    Modifier: getConfiguration('Modifier'),
};
//# sourceMappingURL=index.js.map